export enum LegalType {
  NATURAL_PERSON,
  LEGAL_ENTITY
}

const legalTypeMap: { [key in LegalType]: string } = {
  [LegalType.LEGAL_ENTITY]: 'Persona Moral',
  [LegalType.NATURAL_PERSON]: 'Persona Física'
}

export const legalTypeToString = (val: LegalType) => {
  return legalTypeMap[val];
}
